import { Context, createContext } from "react";

/**
 * FeatureFlagContext is used to share information relating to the enabled features
 * for a user in Flow.
 * Feature Flag Context is usually configued inside the Root component
 * Then useContext(FeatureFlagContext) can be used in child components to hook into flag values.
 */
export const FeatureFlagContext: Context<FeatureFlagContextOptions> = createContext<FeatureFlagContextOptions>({});

interface FeatureFlagContextOptions {
  /**
   * Use this interface to define feature flags
   * the 'exampleFlag' is included only because eslint does not approve of an empty interface.
   */
  exampleFlag?: boolean;
}
